module.exports = __webpack_public_path__ + "img/result_3.67f54399.png";